// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__mapFrame___1p8d2 {\n  flex: 1;\n}", ""]);
// Exports
exports.locals = {
	"mapFrame": "css__mapFrame___1p8d2"
};
module.exports = exports;
